export default "__VITE_ASSET__BJZj9dtn__"